module.exports = __webpack_public_path__ + "img/billet_8.ec2e7693.jpg";